<template>
  <div>
    <!-- register 1 -->
    <section class="reg-1" v-if="first_screen_visible">
      <div class="container">
        <img src="../assets/img/reg-1-icon.png" class="float-right" alt="">
        <form action="reg-1" class="main-form needs-validation-reg-1" novalidate="">
          <div class="col-6">
            <h2 class="title">{{$t('register.header')}}</h2>
            <p class="text">{{$t('register.text1')}}</p>
            <div class="form-group">
              <label for="registration_code">{{$t('register.code')}}</label>
              <input class="form-control" v-bind:class="{'is-invalid':registration_code_error}" type="text"
                     v-model="registration_code" id="registration_code" required>
              <small id="codeOfSetHelpBlock" class="form-text text-muted">
                {{$t('register.code_placement')}} </small>
              <div class="invalid-feedback">{{registration_code_error}}</div>
              <div class="valid-feedback">{{$t('register.code_correct')}}</div>
            </div>
          </div>
          <div class="row text-center buttons">
            <div class="col-12">
              <a href="/#/todo" class="btn btn-dark" data-toggle="modal"
                 data-target="#cancelRegister">{{$t('abort')}}</a>
              <button type="button" class="btn btn-main" id="registration_code_verify_button"
                      @click="verifyCode">{{$t('register.continue_button_label')}}
              </button>
            </div>
          </div>
        </form>
      </div>
    </section>

    <div class="modal fade" id="cancelRegister" tabindex="-1" role="dialog" aria-labelledby="cancelModalLabel"
         aria-hidden="true">
      <div class="modal-dialog" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" id="cancelModalLabel">Caution</h5>
            <button type="button" class="close" data-dismiss="modal" aria-label="Close">
              <span aria-hidden="true">×</span>
            </button>
          </div>
          <div class="modal-body">
            {{$t('register.cancel_confirm')}}
          </div>
          <div class="modal-footer">
            <router-link :to="{name:'home-view'}" class="btn btn-main" data-dismiss="modal">{{$t('yes')}}</router-link>
            <button type="button" class="btn btn-dark" data-dismiss="modal">{{$t('no')}}</button>
          </div>
        </div>
      </div>
    </div>


    <survey-basic v-if="second_screen_visible" :survey_hash="this.survey_hash" v-on:survey-saved="confirmSurvey"
                  v-on:go-back="gotoPage(5)"></survey-basic>

    <!-- register 3 -->
    <section class="reg-3" v-if="third_screen_visible">
      <div class="container">
        <img src="../assets/img/reg-3-icon.png" class="float-right" alt="">
        <div class="col-lg-6 col-md-12">
          <h2 class="title">{{$t('register.enter_password_header')}}</h2>
          <p class="text">{{$t('register.text2')}}</p>
        </div>
        <form action="reg-3" class="main-form needs-validation-reg-3" novalidate="">
          <div class="col-lg-6 col-md-12">
            <div class="form-group row">
              <label for="password" class="col-sm-4 col-form-label">{{$t('register.password')}}:</label>
              <div class="col-sm-8">
                <input type="password" name="password" id="password" class="form-control" required=""
                       v-model="password"/>
                <div class="invalid-feedback">{{$t('register.wrong_pass')}}</div>
              </div>
            </div>
            <div class="form-group row">
              <label for="password_confirm" class="col-sm-4 col-form-label">
                {{$t('register.confirm_password')}}:
              </label>
              <div class="col-sm-8">
                <input type="password" name="password_confirm" id="password_confirm" 
                       class="form-control" required="" v-model="password_confirm"/>
                <div class="invalid-feedback">{{$t('register.wrong_pass')}}</div>
              </div>
            </div>
          </div>
          <div class="col-lg-6 col-md-12">
            <div class="form-group">
              <label for="email" class="col-form-label">{{$t('register.share_email_text')}} </label>
              <input type="email" name="email" id="email" class="form-control" placeholder="This is optional"
                     v-model="email"/>
              <div class="invalid-feedback">{{$t('register.wrong_email')}}</div>
            </div>
          </div>
          <div class="row text-center reg-buttons">
            <div class="col-md-12">
              <button class="btn btn-dark" data-toggle="modal" data-target="#cancelRegister">Abort</button>
              <a href="#" id="register_button" class="btn btn-main" @click="setPassword">{{$t('register.register_button_label')}}</a>
            </div>
          </div>
        </form>
      </div>
    </section>

    <!-- statement -->
    <section class="statement" v-if="fourth_screen_visible">
      <div class="container">
        <div class="col-12 col-box">
          <h2 class="title">{{$t('register.collection_set_registered_message')}}</h2>
          <p class="text">{{$t('register.you_can_sing_in')}}</p>
        </div>

        <div class="row text-center">
          <div class="col">
            <router-link class="btn btn-dark" :to="{name:'home-view'}">
              {{$t('register.go_to_home_page')}}
            </router-link>
          </div>
        </div>
      </div>

    </section>


  </div>
</template>

<script>
  import {DISPLAY_MESSAGE, VERIFY_CODE, REGISTER_PASSWORD} from "../store/actions";
  import SurveyBasic from "../components/surveys/SurveyBasic";
  import Datepicker from 'vuejs-datepicker';

  export default {
    name: "Register",
    components: {Datepicker, SurveyBasic},
    data() {
      return {
        registration_code: '',
        registration_code_error: '',
        first_screen_visible: true,
        second_screen_visible: false,
        third_screen_visible: false,
        fourth_screen_visible: false,
        password: '',
        password_confirm: '',
        email: '',
        errors: {},
        survey_hash: '',
      }
    },
    mounted: function () {
      this.registration_code_error = '';
      this.generateSurveyHash();
    },
    methods: {
      verifyCode: function () {
        if (this.registration_code == ''
          || this.registration_code.length < 16
          || this.registration_code.length > 16) {
          this.registration_code_error = this.$t('register.alerts.incorrect_code')

          return false;
        }
        this.$store.dispatch(VERIFY_CODE,
          {
            registration_code: this.registration_code,
          }).then(() => {
          this.first_screen_visible = false;
          this.second_screen_visible = true;
          this.third_screen_visible = false;
          this.fourth_screen_visible = false;
        }).catch(({response}) => {
          this.errors = response.data;
          this.$store.dispatch(DISPLAY_MESSAGE, {
            message: {
              type: 'danger',
              content: this.$t('register.alerts.incorrect_code_given')
            }
          })
        });
      },
      setPassword: function () {
        if (this.password != this.password_confirm) {
          this.$store.dispatch(DISPLAY_MESSAGE, {
            message: {
              type: 'danger',
              content: this.$t('register.alerts.passwords_different')
            }
          })
          return false;
        }
        if (this.password == '' || this.password_confirm == '') {
          this.$store.dispatch(DISPLAY_MESSAGE, {
            message: {
              type: 'danger',
              content: this.$t('register.alerts.empty_password')
            }
          })
          return false;
        }
        this.$store.dispatch(REGISTER_PASSWORD, {
          registration_code: this.registration_code,
          password: this.password,
          email: this.email,
          survey_hash: this.survey_hash
        }).then(() => {
          this.first_screen_visible = false;
          this.second_screen_visible = false;
          this.third_screen_visible = false;
          this.fourth_screen_visible = true;
        }).catch(({response}) => {
          this.errors = response.data;
        })
      },
      generateSurveyHash() {
        let result = '';
        let characters = 'ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789';
        let charactersLength = characters.length;
        for (let i = 0; i < 32; i++) {
          result += characters.charAt(Math.floor(Math.random() * charactersLength));
        }
        this.survey_hash = result;
      },
      confirmSurvey: function () {
        this.first_screen_visible = false;
        this.second_screen_visible = false;
        this.third_screen_visible = true;
        this.fourth_screen_visible = false;
      },
    }
  }
</script>

<style scoped>

</style>



// WEBPACK FOOTER //
// src/views/Register.vue